import { hydrate } from 'react-dom'
import { RemixBrowser } from 'remix'

hydrate(<RemixBrowser />, document)
